import { ref, readonly } from 'vue';
import { paymentService } from '@/services/paymentService';
// import logoStripe from '@/assets/logo.svg'; // Placeholder, ideally we have real logos
// import logoLemon from '@/assets/lemon-squeezy.svg';
// import logoIyzico from '@/assets/iyzico.svg';

// Shared state
const provider = ref(null);
const isLoading = ref(false);
const error = ref(null);
const initialized = ref(false);

export function usePayment() {
  
  const init = async () => {
    if (initialized.value) return;
    
    isLoading.value = true;
    error.value = null;
    try {
      const data = await paymentService.getActiveProvider();
      provider.value = data.provider;
      initialized.value = true;
    } catch (e) {
      error.value = 'Failed to load payment provider';
      console.error(e);
    } finally {
      isLoading.value = false;
    }
  };

  const getProviderName = () => {
    if (!provider.value) return 'Payment Provider';
    const map = {
      'STRIPE': 'Stripe',
      'LEMON_SQUEEZY': 'Lemon Squeezy',
      'IYZICO': 'Iyzico'
    };
    return map[provider.value] || provider.value;
  };

  const getProviderLogo = () => {
    // In a real app, import specific SVGs
    // For now, return strings or generic logo
    return null; 
  };

  const getSecurityMessage = () => {
    const name = getProviderName();
    return `Secured by ${name}`;
  };

  const createCheckout = async (priceId) => {
    isLoading.value = true;
    error.value = null;
    try {
      const { checkoutUrl } = await paymentService.createCheckoutSession(priceId);
      window.location.href = checkoutUrl;
    } catch (e) {
      error.value = e.message || 'Failed to start checkout';
      throw e;
    } finally {
      isLoading.value = false;
    }
  };

  const openPortal = async () => {
    isLoading.value = true;
    error.value = null;
    try {
      const { portalUrl } = await paymentService.createPortalSession();
      if (portalUrl) {
        window.location.href = portalUrl;
      } else {
        throw new Error('No portal URL returned');
      }
    } catch (e) {
      error.value = e.message || 'Failed to open billing portal';
      throw e;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    provider: readonly(provider),
    isLoading: readonly(isLoading),
    error: readonly(error),
    init,
    getProviderName,
    getProviderLogo,
    getSecurityMessage,
    createCheckout,
    openPortal
  };
}
